export function useBackgroundCheckAPI() {
  const { errors, request } = useRequest();
  
  async function getBackgroundCheckCertificate() {
    const url = versionedUrl('BackgroundCheck/Certificate');
  
    return await request<string>(url);
  }

  return {
    errors,
    getBackgroundCheckCertificate
  };
}
